import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer'; 
import BannerSection from './pages/BannerSection';
import HomePage from './pages/HomePage';
import VisionMissionSection from './pages/VisionMissionSection';
import ProgramsSection from './pages/ProgramsSection';
import DirectorMessagePage from './pages/DirectorMessagePage';
import ProgramPage from './pages/ProgramPage';
import OurPeoplePage from './pages/OurPeoplePage';
import BoardMemberPage from './pages/BoardMemberPage';
import LeadershipPage from './pages/LeadershipPage';
import CareerPage from './pages/CareerPage';
import LoginPage from './pages/LoginPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import DonationPage from './pages/DonationPage';
import AboutUs from './pages/AboutUs';
import VolunteerPage from './pages/VolunteerPage';




const Home = () => (
  <>
    <BannerSection/>
    <HomePage/>
    <VisionMissionSection />
    <DonationPage/>
    <ProgramsSection />
    <VolunteerPage/>
    <ContactPage />

  </>
);

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-orange-50 flex flex-col">
        <Navbar />
        
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Director's -message" element={<DirectorMessagePage />} />
            <Route path="/program" element={<ProgramPage />} />
            <Route path="/our-people" element={<OurPeoplePage />} />
            <Route path="/board-member" element={<BoardMemberPage />} />
            <Route path="/leadership" element={<LeadershipPage />} />
            <Route path="/volunteer" element={<VolunteerPage />} />
            <Route path="/career" element={<CareerPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy"element={<PrivacyPolicyPage/>}/>
            <Route path="/terms"element={<TermsPage/>}/>
            <Route path="/donation"element={<DonationPage/>}/>
             <Route path="/about-us"element={< AboutUs/>}/>

          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;